import React from 'react'
import Notification from '../Notification/Notification'
import { NotificationData } from '../../../services/Notifications/notification.type'

type NotificationProps = {
    notifications: any[]
}


const NotificationCard = ({ notifications }: NotificationProps) => {

    return (
        <div
            className="atendoo-card"
        >
            <h6 className="subtitle mb-3">
                Novedades
            </h6>

            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {notifications?.map((n: NotificationData) => (
                    <Notification notification={n} key={n.id} />
                ))}
            </div>
        </div>
    )
}

export default NotificationCard